import React from 'react';
import {View} from 'MWC';

export default class BaseListComponent extends View {
    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false
        };
        this.toggleModal = this.toggleModal.bind(this);
        return this;
    }

    componentReady() {
        if (window.location.href.endsWith('?credits')) {
            document
                .getElementById('credits-anchor')
                .scrollIntoView({block: 'start', behavior: 'smooth'});
        }
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }
}
